import { ChangeDetectorRef, Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { ConstantesApp } from 'src/app/app.config/constantes-app';

@Directive({
  selector: '[soloNumerosDecimal]'
})
export class SoloNumerosDecimalesDirective {

    constructor(private control: NgControl) { }

    /**
     * 
     * @param value Valor ingresado por el usuario en el input aplicando la directiva
     */
    @HostListener('input', ['$event.target.value'])
    onInput(value: string) {
        // Reemplazar punto por coma
        const newValue = value.replace(/[\.,]/g, ',');

        // Validar que solo haya un punto o coma decimal
        const regex = /^[\d,]+$/;          
        if (regex.test(newValue)) {
        this.control.control?.setValue(newValue, { emitEvent: false });
        } else {
        // Si la entrada no es válida, mantener el valor anterior
        this.control.control?.setValue(this.control.value, { emitEvent: false });
        }
    
    }

    /**
     * 
     * @param event Evento KeyboardEvent capturado al ingresar en el input con la directiva
     * @returns 
     */
    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        // Permitir las teclas de navegación, borrar y tabulación
        if ([46, 8, 9, 27, 13].indexOf(event.keyCode) !== -1 ||
        // Permitir: Ctrl+A
        (event.keyCode === 65 && event.ctrlKey === true) ||
        // Permitir: Ctrl+C
        (event.keyCode === 67 && event.ctrlKey === true) ||
        // Permitir: Ctrl+V
        (event.keyCode === 86 && event.ctrlKey === true) ||
        // Permitir: Ctrl+X
        (event.keyCode === 88 && event.ctrlKey === true)) {
        return;
        }

        // Permitir números, el punto decimal y la coma
        if ((event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105) && event.keyCode !== 190 && event.keyCode !== 110 && event.keyCode !== 188) {
        event.preventDefault();
        }
    }
}